import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Store } from '@src/store';
// import { ProjectsComparatorService } from "../../../../../services/projectsComparator";
import { projectActions } from "../../../../../store/reducers/projectReducer";
import { logsActions } from "../../../../../store/reducers/logsReducer";
import * as _ from 'lodash';



@Component({
    selector: 'reports-audit-filter',
    template: require('./reports-audit-filter.component.html'),
    styles: [require('./reports-audit-filter.component.scss')]
})
export class ReportFilterComponent implements OnInit, OnDestroy {
    public objects = [
        { id: "-1", name: "ALL", exmaple: "e.g. my_tabs" },
        { id: "0", name: "=", exmaple: "e.g. my_tabs" },
        { id: "1", name: "CONTAINS", exmaple: "e.g. my_tabs" },
        { id: "2", name: "IN", exmaple: "e.g. tab1,tab2" }
    ];

    public projects: any;
    public exemple: string = "e.g. my_tabs";
    public unSubscribe: any;
    public today = new Date();
    public allowedOperation: boolean = true;
    public blockedOperation: boolean = true;
    public blockedReapedtedScheme: boolean = false;
    public fromDate: Date = new Date(this.today.setDate(this.today.getDate() - 30));
    public toDate: Date = new Date();
    public selectedProject: any
    public selectedEnviroment: any
    public envs = [];
    public selectedobject = "ALL";
    public waitingForResponse: boolean = false;
    public waitingForResponseSchemas: boolean = false;
    public countRequestForAll: number = 0
    public schemas: any;
    public selectedSchema: any;
    public objectNameFilter: string;
    isCustom: boolean;
    initFrom: boolean;
    initTo: boolean;
    toDateInValid: boolean;



    @Output() public filter = new EventEmitter();
    constructor(private store: Store) {
    }




    public async ngOnInit() {

        this.unSubscribe = this.store.subscribe(() => {

            this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus
            if (this.waitingForResponse && this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus) {
                this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus.forEach(obj => {
                    obj.environments.forEach(env => this.envs.push(env));
                    this.waitingForResponse = false;
                })
                let ids = this.envs.map(obj => obj.id)
                if (ids.length > 0)
                    this.envs = [{ 'id': ids, 'name': 'All', isAll: true }, ...this.envs];
                this.selectedEnviroment = this.envs[0].name;
                this.setSchemas();
            }

            if (this.waitingForResponseSchemas && this.store.getState().logs.schemas) {
                if (this.countRequestForAll > 0) {
                    this.countRequestForAll--;
                    if (this.countRequestForAll == 0)
                        this.waitingForResponseSchemas = false;
                } else {
                    this.waitingForResponseSchemas = false;
                }
                Object.keys(this.store.getState().logs.schemas).forEach(key => {
                    if (!this.schemas.find(sch => sch.id === key)) {
                        this.schemas.push({ 'id': key, 'name': this.store.getState().logs.schemas[key] });
                    }

                })
                let ids = this.schemas.map(obj => obj.id)
                if (ids.length > 0 && this.schemas.length > 0 && this.schemas[0].isAll == true)
                    this.schemas[0] = { 'id': ids, 'name': 'All', isAll: true };
                else if (ids.length > 0)
                    this.schemas = [{ 'id': ids, 'name': 'All', isAll: true }, ...this.schemas];
                this.selectedSchema = this.schemas[0].name;
            }

            let projectItems = this.store.getState().projects.projectWithDeployItems;
            if (!this.projects && projectItems && projectItems.length > 0) {
                this.projects = _.filter(projectItems, (item) => !item.isDraft)
                this.selectedProject = this.projects[0].name;
                if (this.selectedProject) {
                    this.setEnvs();
                }
            }
        });



    }


    setSchemas() {
        this.store.dispatch({ type: logsActions.CLEAR_SCHEMAS_FOR_LOG });
        const ProjectSelected = this.projects.find(x => x.name == this.selectedProject)
        const EnvSelected = this.envs.find(x => x.name == this.selectedEnviroment)
        this.schemas = [];
        this.selectedSchema = null;
        this.countRequestForAll = 0;
        this.waitingForResponseSchemas = true;
        if (EnvSelected.isAll == true) {
            this.countRequestForAll = EnvSelected.id.length;
            EnvSelected.id.forEach(id => {
                this.waitingForResponseSchemas = true;
                this.store.dispatch({
                    type: logsActions.GET_SCHEMAS_FOR_LOG,
                    payload: { projectId: ProjectSelected.id, envId: id }
                });
            })
        } else {
            this.store.dispatch({
                type: logsActions.GET_SCHEMAS_FOR_LOG,
                payload: { projectId: ProjectSelected.id, envId: EnvSelected.id }
            });
        }
    }


    ngOnDestroy() {
        this.schemas = null;
        this.unSubscribe();
    }


    getOblectExemple() {
        let SelectedObj = this.objects.find(x => x.name === this.selectedobject)
        this.exemple = SelectedObj.exmaple
    }


    setEnvs() {
        this.envs = [];
        this.selectedEnviroment = null;
        this.selectedSchema = null;
        const ProjectSelected = this.projects.find(x => x.name == this.selectedProject)
        if (ProjectSelected.id != -1) {
            this.waitingForResponse = true;
            this.store.dispatch({
                type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
                payload: { projId: ProjectSelected.id }
            });
        }
    }

    selectedTime(data) {
        this.fromDate = new Date(data.value.fromDate);
        this.toDate = new Date(data.value.toDate);
        this.isCustom = (data.name == 'Custom') ? true : false;
        if (this.isCustom) {
            this.initFrom = false;
            this.initTo = false;
        }
    }


    inValidToDate(state) {

        if (state == true) {
            this.toDateInValid = true;
            return 'inValidDate';
        }
        this.toDateInValid = false;
        return "";
    }


    public onFilter(): void {
        let SelectedObj = this.objects.find(x => x.name === this.selectedobject)
        let projectSelectedObj = this.projects.find(x => x.name === this.selectedProject)
        let environmentObj = this.envs.find(x => x.name === this.selectedEnviroment)
        let SchemaObj = this.schemas.find(x => x.name === this.selectedSchema)
        this.filter.emit({
            data: {
                project: projectSelectedObj,
                fromDate: this.fromDate,
                toDate: this.toDate,
                schema: (SchemaObj.name == 'All') ? null : SchemaObj,
                env: environmentObj,
                objectName: SelectedObj,
                allowedOperation: this.allowedOperation,
                blockedOperation: this.blockedOperation,
                objectNameFilter: this.objectNameFilter
            }
        });

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/report-details-an7/reports-audit-filter/reports-audit-filter.component.ts